/**
* 基础菜单 店铺装饰管理
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <!-- <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>店铺管理</el-breadcrumb-item>
        <el-breadcrumb-item>店铺装饰管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div> -->
    <div class="flex_box">
      <div class="address">
        <div class="ment flex_box ">
          <p class="text f16 fontWeight">banner图片</p>
          <el-row class="yten mt16">
            <el-button type="primary" plain size="mini" @click="edit">编辑</el-button>
          </el-row>
        </div>
        <div class="ping">
              <el-image
                style="width: 100%; height: 174px"
                :src="tableData.banner_img_url"
                :preview-src-list="srcList">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
        </div>
        <p class="f12 colorD9001B pding">图片尺寸690px*300px，单张图片大小不得超过1M，仅支持jpg、jpeg、png格式</p>
      </div>

      <div class="address">
        <div class="ment flex_box ">
          <p class="text f16 fontWeight">banner背景图片</p>
          <el-row class="yten mt16">
            <el-button type="primary" plain size="mini" @click="edit1">编辑</el-button>
          </el-row>
        </div>
        <div class="ping">
            <el-image
              style="width: 100%; height: 174px"
              :src="tableData1.banner_bk_img_url"
              :preview-src-list="srcBkList">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
        </div>
        <p class="f12 colorD9001B pding">图片尺寸750px*380px，单张图片大小不得超过1M，仅支持jpg、jpeg、png格式</p>
      </div>
    </div>


    <!-- 弹窗 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="编辑店铺banner"
               :visible.sync="editDialogVisible"
               width="30%"
               >
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="编辑banner图片" name="first">
          <el-form :model="addshopForm" :rules="rules" ref="addshopForm" class="addshopForm">
            <el-form-item label="banner图片" prop="banner_img_url">
              <el-upload
                class="avatar-uploader"
                action="#"
                :show-file-list="false"
                :on-remove="handleRemove"
                :http-request="handleUpload"
                :before-upload="beforeUpload">
                <img v-if="form.image" :src="form.image" class="avatar"/>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="编辑banner背景图片" name="second">
            <el-form :model="addshopForm" :rules="bkrules" ref="addshopForm1" class="addshopForm">
              <el-form-item label="banner背景图片" prop="banner_bk_img_url">
                <el-upload
                  class="avatar-uploader"
                  action="#"
                  :show-file-list="false"
                  :on-remove="bkhandleRemove"
                  :http-request="bkhandleUpload"
                  :before-upload="bkbeforeUpload">
                  <img v-if="form1.image" :src="form1.image" class="avatar"/>
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
            </el-form>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer" center>
            <el-button class="mr50" type="primary" @click="sure('addshopForm')">确 定</el-button>
            <el-button @click="handleClose()">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    shopBannerInfo,    // 详情
    shopBannerAdd,     // 新增
    shopBannerUpdate   // 修改
  } from '../../api/basisMG'
  import {getToken, uploadImgTmp} from '../../api/commonMG'
  import {uploadFile} from "../../utils/util";

  export default {
    data: () => {
      return {
        loading: false, //是显示加载
        editDialogVisible: false, //控制页面显示与隐藏
        editDialogVisible1: false, //控制页面显示与隐藏
        imgUrl: '',
        imgBkUrl: '',
        activeName:'first',
        dialogImageUrl: '',
        dialogVisible: false,
        srcList: [],
        srcBkList:[],
        tableData: {
          id: '',
          banner_img_id: '',
          banner_img_url: ''
        },
        tableData1: {
          id: '',
          banner_bk_img_id: '',
          banner_bk_img_url: ''
        },
        addshopForm: {
          id: '',
          banner_img_id: '',
          banner_img_url: '',
          banner_bk_img_id: '',
          banner_bk_img_url: ''
        },
        rules: {
          banner_img_url: [{required: true, message: '请选择banner图片', trigger: 'blur'}]
        },
        bkrules: {
          banner_bk_img_url: [{required: true, message: '请选择banner背景图片', trigger: 'blur'}]
        },
        form: {
          image: ''
        },
        form1: {
          image: ''
        },
        id: '',
      }
    },
    // 注册组件
    components: {},

    /**
     * 创建完毕
     */
    created() {
      this.getdata()
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        shopBannerInfo()
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if(res.content) {
                this.addshopForm = res.content;
                this.tableData = res.content;
                this.tableData1 = res.content;
                this.form.image = res.content.banner_img_url;
                this.form1.image = res.content.banner_bk_img_url;
                this.imgUrl = res.content.banner_img_url;
                this.imgBkUrl = res.content.banner_bk_img_url;
                this.srcList.push(res.content.banner_img_url)
                this.srcBkList.push(res.content.banner_bk_img_url)
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      edit() {
        this.editDialogVisible = true;
        this.activeName = 'first'
      },
      edit1() {
        this.editDialogVisible = true;
        this.activeName = 'second'
      },
      sure() {
        this.addshopForm.banner_img_url = this.imgUrl;
        this.addshopForm.banner_bk_img_url = this.imgBkUrl;
        this.loading = true;
        if(!this.addshopForm.id) {
          this.addshopForm.banner_img_id = '';
          this.addshopForm.banner_bk_img_id = '';
          shopBannerAdd(this.addshopForm)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功编辑banner图片!'
                })
                this.editDialogVisible = false;
                this.getdata()
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误,请稍后再试!')
            })
        } else {
          shopBannerUpdate(this.addshopForm)
            .then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'success',
                  message: '您已成功编辑banner图片!'
                })
                this.editDialogVisible = false;
                this.getdata()
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('网络错误,请稍后再试!')
            })
        }
      },
      handleRemove(file) {
        console.log(file);
      },
      bkhandleRemove(file) {
        console.log(file);
      },
      handleClick() {

      },
      handleClose() {
        this.editDialogVisible = false
      },
      handleClose1() {
        this.editDialogVisible1 = false
      },
      // 限制图片尺寸
      limitFileWH(E_width, E_height, file) {
        const _this = this
        let imgWidth = ''
        let imgHight = ''
        const isSize = new Promise(function (resolve, reject) {
          const width = E_width
          const height = E_height
          const _URL = window.URL || window.webkitURL
          const img = new Image()
          img.onload = function () {
            imgWidth = img.width
            imgHight = img.height
            const valid = img.width === width && img.height === height
            valid ? resolve() : reject()
          }
          img.src = _URL.createObjectURL(file)
        }).then(() => {
          // const fileData = new FormData();
          // fileData.append("file", file);
          // //upload为上传的接口
          // uploadImgTmp(fileData).then(res => {
          //   this.imgUrl = res.content;
          //   //对返回的图片地址进行回显
          //   this.$set(this.form, "image", res.content);
          // });
          getToken().then(res => {
            if(res) {
              let result = uploadFile(res,file);
              result.then(res => {
                this.imgUrl =  res.data.content.file.fileUrl;
                //对返回的图片地址进行回显
                this.$set(this.form, "image",  res.data.content.file.fileUrl);
              })
            }
          });
          //阻止传到本地浏览器
          return false;
        }, () => {
          _this.$message.error({
            message: '上传图片的尺寸应为' + E_width + '*' + E_height + '，当前上传图片的尺寸为：' + imgWidth + '*' + imgHight,
            btn: false
          })
          return false
        })
        return isSize
      },
      limitFileWH1(E_width, E_height, file) {
        const _this = this
        let imgWidth = ''
        let imgHight = ''
        const isSize = new Promise(function (resolve, reject) {
          const width = E_width
          const height = E_height
          const _URL = window.URL || window.webkitURL
          const img = new Image()
          img.onload = function () {
            imgWidth = img.width
            imgHight = img.height
            const valid = img.width === width && img.height === height
            valid ? resolve() : reject()
          }
          img.src = _URL.createObjectURL(file)
        }).then(() => {
          // const fileData = new FormData();
          // fileData.append("file", file);
          // //upload为上传的接口
          // uploadImgTmp(fileData).then(res => {
          //   this.imgBkUrl = res.content;
          //   //对返回的图片地址进行回显
          //   this.$set(this.form1, "image", res.content);
          // });
          getToken().then(res => {
            if(res) {
              let result = uploadFile(res,file);
              result.then(res => {
                this.imgBkUrl =  res.data.content.file.fileUrl;
                //对返回的图片地址进行回显
                this.$set(this.form1, "image",  res.data.content.file.fileUrl);
              })
            }
          });
          //阻止传到本地浏览器
          return false;
        }, () => {
          _this.$message.error({
            message: '上传图片的尺寸应为' + E_width + '*' + E_height + '，当前上传图片的尺寸为：' + imgWidth + '*' + imgHight,
            btn: false
          })
          return false
        })
        return isSize
      },
      beforeUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type == "image/png";
        const isLt2M = file.size / 1024 / 1024 < 1;
        // if (!isJPG) {
        //   this.$message.error("上传图片仅支持jpg、jpeg、png格式!");
        //   return;
        // }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 1MB!");
          return;
        }
        // 调用[限制图片尺寸]函数
        this.limitFileWH(690, 300, file)
      },
      bkbeforeUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type == "image/png";
        const isLt2M = file.size / 1024 / 1024 < 1;
        // if (!isJPG) {
        //   this.$message.error("上传图片仅支持jpg、jpeg、png格式!");
        //   return;
        // }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 1MB!");
          return;
        }
        // 调用[限制图片尺寸]函数
        this.limitFileWH1(750, 380, file)
      },

      // 可以获取图片参数
      handleUpload(file) {
        console.log(file)
      },
      bkhandleUpload(file) {
      },
    }
  }
</script>


<style scoped>
  .contianer {
    height: calc(100% - 60px);
    background: #fff;
    padding: 20px;
    border-radius: 8px;
  }

  /deep/ .textarea .el-textarea__inner {
    height: 120px;
    width: 320px;
    resize: none;
  }

  /deep/ .addshopForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .addshopForm .el-input--small {
    width: 320px;
  }

  .mt16 {
    margin-top: 16px;
  }

  .mt20 {
    margin-top: 20px;
  }

  .mt50 {
    margin-top: 50px;
  }

  .ml100 {
    margin-left: 100px;
  }

  .mr10 {
    margin-right: 10px;
  }

  .mr50 {
    margin-right: 50px;
  }

  .f12 {
    font-size: 12px;
  }

  .f16 {
    font-size: 16px;
  }

  .f20 {
    font-size: 20px;
  }

  .colorD9001B {
    color: #D9001B;
  }

  .color333 {
    color: #333333;
  }

  .fontWeight {
    font-weight: 600;
  }

  .flex_box {
    display: flex;
  }

  .colorred {
    color: red;
  }

  .flex_box {
    display: flex;
  }

  .ping {
    padding: 8px 12px;
    border-bottom: 1px solid #EBEEF5;
    margin-top: 10px;
  }

  /deep/ .el-form-item__label {
    width: 125px;
  }

  /deep/ .el-form-item__content {
    line-height: 0;
  }

  /deep/ .el-form-item {
    margin-bottom: 0!important;
  }

  .pding {
    padding: 10px 12px;
  }

  /deep/ .yten .el-button--mini {
    padding: 5px 23px!important;
  }

  .billing_item span {
    height: 40px;
    padding-left: 12px;
    padding-right: 15px;
    width: 300px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }

  .copy {
    width: 20px;
    height: 20px;
  }

  .copy img {
    width: 20px;
    height: 20px;
  }

  .saleTitle {
    color: #333333;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 12px;
    margin-top: 25px;
  }

  .picTitle {
    color: #333333;
    font-size: 15px;
    font-weight: 400;
    margin: 20px 0;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .address {
    margin: 30px 0 0 36px;
    border: 1px solid #EBEEF5;
    border-radius: 10px;
  }

  .ment {
    padding: 0 12px;
    justify-content: space-between;
  }

  .text {
    font-family: 'PingFang SC';
    font-style: normal;
    line-height: 28px;
    color: #409EFF;
    margin-top: 12px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar {
    width: 300px;
    height: 150px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 300px;
    height: 150px;
    line-height: 150px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  /deep/ .image-slot {
    text-align: center;
    margin-top: 25%;
    transform: translateY(-50%);
  }

  /deep/ .el-descriptions-row th {
    width: 120px !important;
    border: 0 !important;
    background: #F5F7FA;
  }

  /deep/ .el-descriptions-row td {
    border: 0 !important;
  }

  /deep/ .el-dialog__footer {
    text-align: center!important;
  }

</style>





// WEBPACK FOOTER //
// src/views/store/storeDecoration.vue